<template>
  <div class="vx-col w-full lg:w-3/4 mb-base">
    <vx-card :title="day">
      <div class="vx-row mb-6 w-full">
        <div class="vx-col sm:w-1/5 w-full">
          <span class="day">Status</span>
        </div>
        <div class="vx-col sm:w-3/5">
          <vs-switch v-model="openingHours.isOpen">
            <span slot="on">Open</span>
            <span slot="off">Closed</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-6 w-full" v-if="openingHours.isOpen">
        <div class="vx-col sm:w-1/5 w-full">
          <span class="day">Open at</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <v-date-picker
            v-if="openingHours.isOpen"
            class="custom-time-picker"
            is24hr
            mode="time"
            v-model="openingHours.open"
            :timezone="timezone"
          />

        </div>
      </div>
      <div class="vx-row mb-6 w-full" v-if="openingHours.isOpen">
        <div class="vx-col sm:w-1/5 w-full">
          <span class="day">Close at</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <v-date-picker
            v-if="openingHours.isOpen"
            class="custom-time-picker"
            is24hr
            mode="time"
            v-model="openingHours.close"
            :timezone="timezone"
          />
        </div>
      </div>
      <div class="vx-row mb-6 w-full" v-if="openingHours.isOpen">
        <div class="vx-col sm:w-1/5 w-full">
          <span class="day">Details</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row>
            <vs-input label="Dresscode" v-model="openingHours.dressCode" />
            <vs-input
              label="Age restriction"
              class="ml-3"
              v-model="openingHours.ageRestriction"
          /></vs-row>
          <vs-row>
            <vs-input
              type="number"
              label="Entrance price"
              style="width: 100px"
              class="mr-3"
              v-model="openingHours.entrancePrice" />
            <vs-input label="Entrance note" v-model="openingHours.entranceNote"
          /></vs-row>
          <vs-row>
            <vs-input
              label="Wardrobe price"
              style="width: 100px"
              class="mr-3"
              type="number"
              v-model="openingHours.wardrobePrice" />
            <vs-input label="Wardrobe note" v-model="openingHours.wardrobeNote"
          /></vs-row>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: ["day", "openingHours"],
  data() {
    return {
      timezone: ""
    };
  },
  computed: {},
  methods: {},
  async mounted() {
    console.log("Mounted with", this.openingHours);
  },
};
</script>

<style>
.custom-time-picker .vc-date {
  display: none !important;
}
</style>




<style lang="scss" scoped>

.day {
  font-weight: 500;
  width: 100px;
}

.opening-hours-row {
  display: flex;
  align-items: center;
  min-height: 40px;
}
</style>